export default __webpack_public_path__ + "static/media/kitchen3-afterE-1024w.8c836693.png";